import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Employee } from '../../../../../generated/generated-types';
import { EmployeeHeaderCardWidgetComponent } from '../employee-header-card-widget/employee-header-card-widget.component';

@Component({
  selector: 'app-formly-employee-header-card-widget',
  templateUrl: './formly-employee-header-card-widget.component.html',
  styleUrls: ['./formly-employee-header-card-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EmployeeHeaderCardWidgetComponent,
  ]
})
export class FormlyEmployeeHeaderCardWidgetComponent extends FieldType {

  async onAssetChoose(resolveCallback: () => Promise<void>) {
    const { detailComponent, detailModel } = this.getDetailComponentAndModel();
    if (detailComponent && detailModel && detailComponent.modelIsDirtySig()) {
      await detailComponent.save(detailModel, null, true);
    }
    await resolveCallback();
  }

  async onEmployeeChanged(employee: Employee) {
    const { detailComponent, detailModel } = this.getDetailComponentAndModel();
    if (detailComponent && detailModel) {
      if (detailModel.employee != null) {
        await detailComponent.setModel({
          ...detailModel,
          employee: { ...detailModel.employee, ...employee },
        });
        if (typeof detailComponent.refreshUserSession === 'function') {
          await detailComponent.refreshUserSession();
        }
      } else {
        await detailComponent.setModel({ ...detailModel, ...employee });
      }
    }
  }

  getDetailComponentAndModel() {
    const detailComponent = this.options?.formState?.detailComponent;
    if (detailComponent?.detailModelSig()) {
      const detailModel = detailComponent.detailModelSig();
      return { detailComponent, detailModel };
    }
    return { detailComponent, detailModel: null };
  }
}
